import type { HttpClient } from '../core/http.js';
import type { RequestOptions } from '../types/common.js';
import type { Bank } from '../types/bank.js';

/**
 * The catalogue of banks GPM Pay supports.
 *
 * @remarks
 * Scope: `bank-accounts:read`.
 *
 * You only need this when you want a bank *you have no account at* — to render
 * a bank picker, or to build a VietQR for an external account. For your own
 * accounts the NAPAS `bin` already rides along on the `bank` relation of
 * `bankAccounts.list()` / `bankAccounts.retrieve()`, so no extra call is needed.
 */
export class BanksResource {
  constructor(private readonly http: HttpClient) {}

  /** List active banks. The endpoint returns a flat array, not a page. */
  async list(options: RequestOptions = {}): Promise<Bank[]> {
    const page = await this.http.requestList<Bank>('GET', '/banks', options);
    return page.data;
  }
}
